import InStockAlertLink from './InStockAlertLink'

export default InStockAlertLink
